import { atom } from 'jotai';
import { preferencesAtom } from './tempPrefsAtom'; // To potentially update after revert
import { userPrefsAtom } from './userPrefsAtom'; // To potentially update after revert

// This atom holds the state of the preset override
export const presetStateAtom = atom({
    isActive: false,
    originalUserPrefs: null, // Store the original userPrefs array here
    presetName: null, // Optional: store the name of the active preset
});

// This is a write-only atom used to trigger the reversion process
export const revertPresetAtom = atom(null, (get, set) => {
    const { originalUserPrefs } = get(presetStateAtom);
    const isActive = get(presetStateAtom).isActive;

    if (isActive && originalUserPrefs) {
        // console.log("Reverting preset changes via Jotai...");
        // 1. Restore userPrefsAtom using its setter via the 'set' function
        set(userPrefsAtom, originalUserPrefs); // Update userPrefsAtom with restored values

        // 2. Reset the preset state atom
        set(presetStateAtom, { isActive: false, originalUserPrefs: null, presetName: null });

        // 3. Force re-read/update of atoms dependent on userPrefs/localStorage
        //    This tells Jotai that the underlying source for userPrefsAtom might have changed.
        //    The exact implementation might depend on how userPrefsAtom is defined,
        //    but forcing a reset or re-read is often necessary after direct localStorage manipulation.
        //    If userPrefsAtom reads directly from localStorage on each access, this might be automatic.
        //    If it caches, we need to invalidate it. Setting it above should handle this.

        // 4. Update preferencesAtom as well, merging the restored userPrefs
        //    We need to reconstruct the state that preferencesAtom should have
        //    based on the *reverted* userPrefs.
        const currentPreferences = get(preferencesAtom);
        const restoredUserPrefsMap = originalUserPrefs.reduce((acc, pref) => {
            acc[pref.name] = pref.checked;
            return acc;
        }, {});

        // Create a new preferences object based on current state but overriding
        // with the restored user preferences.
        const revertedPreferences = {
            ...currentPreferences,
            ...restoredUserPrefsMap, // Overwrite with restored values
        };
        set(preferencesAtom, revertedPreferences); // Update the main preferences atom

        // console.log("Preset reverted. userPrefsAtom and preferencesAtom updated.");

    } else {
        // console.log("No active preset to revert or original preferences missing.");
    }
});
